
/**
 * Takes two dates and return Differents in Round Hours/Days
 * @param {*} argDate1
 * @param {*} argDate2
 */
export function calculateDuration(argDate1, argDate2){
    //convert millisecond to hours
    var diff = Math.abs(argDate1-argDate2)/3600000;
        var days = Math.round(diff/24);
        if(days === 0){
          var time = Math.round(diff);
          console.log("time time =",time);
          if (diff > 1){
            return time +" Hour(s)"
          }else if(diff <= 1  && diff > 0)
            return   "less than 1 hour";
        }
        else{
            return days+" Day(s)"
        }
}
/**
 * Takes Seconds and input and covert into HH:MM:SS format string
 * @param {*} sec_num
 */
export function timeElapseDisplay(sec_num){
    var hours   = Math.floor(sec_num / 3600);
    var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
    var seconds = sec_num - (hours * 3600) - (minutes * 60);

    if (hours   < 10) {hours   = "0"+hours;}
    if (minutes < 10) {minutes = "0"+minutes;}
    if (seconds < 10) {seconds = "0"+seconds;}
    return hours+':'+minutes+':'+seconds;
}
